import { createReducer } from '@reduxjs/toolkit';
import authActions from '../auth/auth-actions';
import {
  getTransactionsRequest,
  getTransactionsSuccess,
  getTransactionsError,
  getTransactionsByDateRequest,
  getTransactionsByDateSuccess,
  getTransactionsByDateError,
  addTransactionRequest,
  addTransactionSuccess,
  addTransactionError,
  deleteTransactionRequest,
  deleteTransactionSuccess,
  deleteTransactionError,
  updateTransactionRequest,
  updateTransactionSuccess,
  updateTransactionError,
} from '../transaction/actions-transactions';

const isLoading = createReducer(false, {
  [authActions.regRequest]: () => true,
  [authActions.regSuccess]: () => false,
  [authActions.regError]: () => false,
  [authActions.signInRequest]: () => true,
  [authActions.signInSuccess]: () => false,
  [authActions.signInError]: () => false,
  [authActions.signOutRequest]: () => true,
  [authActions.signOutSuccess]: () => false,
  [authActions.signOutError]: () => false,
  [authActions.getCurrentUserRequest]: () => true,
  [authActions.getCurrentUserSuccess]: () => false,
  [authActions.getCurrentUserError]: () => false,
  [authActions.uploadAvatarRequest]: () => true,
  [authActions.uploadAvatarSuccess]: () => false,
  [authActions.uploadAvatarError]: () => false,
  [getTransactionsRequest]: () => true,
  [getTransactionsSuccess]: () => false,
  [getTransactionsError]: () => false,
  [getTransactionsByDateRequest]: () => true,
  [getTransactionsByDateSuccess]: () => false,
  [getTransactionsByDateError]: () => false,
  [addTransactionRequest]: () => true,
  [addTransactionSuccess]: () => false,
  [addTransactionError]: () => false,
  [deleteTransactionRequest]: () => true,
  [deleteTransactionSuccess]: () => false,
  [deleteTransactionError]: () => false,
  [updateTransactionRequest]: () => true,
  [updateTransactionSuccess]: () => false,
  [updateTransactionError]: () => false,
});

export default isLoading;
